export default "__VITE_ASSET__C1Nazcl7__"